import { useInfiniteQuery } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { mapChatMessage } from "web_myplann/Chat/Helpers/mapChatMessage";
import { postChatDetailList } from "web_myplann/Infrastructure/ApiOld/Api";

export const useChatMessagesQuery = (conversationId: number | null) =>
	useInfiniteQuery({
		queryKey: ChatKeys.messages(conversationId),
		enabled: conversationId !== null,
		initialPageParam: 1,
		queryFn: ({ pageParam }) =>
			postChatDetailList({ id: conversationId!, page: pageParam }),
		getNextPageParam: (lastPage, allPages) => {
			const data = lastPage?.status === 200 ? lastPage.data.data : undefined;
			return data?.isNextPage ? allPages.length + 1 : undefined;
		},
		select: (data) =>
			data.pages.flatMap((page) =>
				page?.status === 200 ? page.data.data.items.map(mapChatMessage) : [],
			),
	});
